module.exports = __webpack_public_path__ + "img/home-icon.15de6de1.svg";